module.exports = __webpack_public_path__ + "img/icon.20e8212.png";